<div
  class="tw-pt-5 purchase-ai-credits"
  rvSpinner="purchase-ai-credits-loader"
  [rvShowSpinner]="purchaseAiCreditsService.loading"
>
  @if (purchaseAiCreditsService.apiError) {
    <notification-alert
      id="purchase-ai-credits-error"
      type="danger"
      [title]="purchaseAiCreditsService.apiError"
      message="If you need help please email us at support@risevision.com"
      cssClass="u_margin-md-top"
    >
    </notification-alert>
  }
  @if (purchaseAiCreditsService.estimate.estimateError) {
    <notification-alert
      id="purchase-ai-credits-estimate-error"
      type="danger"
      [title]="purchaseAiCreditsService.estimate.estimateError"
      cssClass="u_margin-md-top"
    >
    </notification-alert>
  }

  <div id="purchase-ai-credits-panel" class="row">
    <div class="col-md-8 col-md-offset-2">
      <form
        [formGroup]="form"
        id="forms.purchaseAiCreditsForm"
        role="form"
        novalidate
        (ngSubmit)="continue()"
      >
        <h4 class="u_margin-md-bottom">Purchase Details</h4>
        <div class="border-container p-4">
          <div
            class="left-right-aligner purchase-ai-credits__quantity-row"
            [class.has-error]="
              form.controls.quantity.invalid && form.controls.quantity.touched
            "
          >
            <label for="aiCreditsQuantity" class="control-label mb-0"
              >Additional AI Credits you want to buy:</label
            >
            <rv-quantity
              id="aiCreditsQuantity"
              formControlName="quantity"
              enforceStep
              [step]="quantityStep"
              [min]="quantityMin"
              [required]="true"
              ariaLabel="Additional AI Credits quantity"
            ></rv-quantity>
          </div>

          <div class="purchase-ai-credits__schedule mt-4">
            <payment-schedule-picker
              formControlName="scheduleProductCode"
              [options]="purchaseAiCreditsService.scheduleOptions"
              [quantity]="form.controls.quantity.value"
              [disabled]="purchaseAiCreditsService.loading"
            ></payment-schedule-picker>
          </div>

          <div class="pt-4">
            @if (!addCoupon) {
              <a
                rv-link
                id="addCouponLink"
                href=""
                (click)="$event.preventDefault(); addCoupon = true"
                >Add A Coupon Code</a
              >
            } @else {
              <div class="row">
                <div class="col-md-8">
                  <label class="tw-sr-only" for="couponCodeInput"
                    >Coupon code</label
                  >
                  <input
                    id="couponCodeInput"
                    type="text"
                    class="form-control"
                    name="couponCode"
                    [(ngModel)]="couponCode"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="Coupon code"
                  />
                </div>
                <div class="col-md-4">
                  <button
                    rv-button
                    variant="secondary"
                    type="button"
                    class="tw-w-full"
                    (click)="applyCouponCode()"
                  >
                    Apply
                  </button>
                </div>
              </div>
              <a
                rv-link
                class="d-inline-block mt-2"
                href=""
                (click)="$event.preventDefault(); clearCouponCode()"
                >Clear coupon</a
              >
            }
          </div>

          <div class="pt-4">
            <p class="left-right-aligner mb-4">
              <span class="font-weight-bold">Amount due now:</span>
              <span>
                <span class="u_margin-right text-subtle">{{
                  purchaseAiCreditsService.estimate.currencyCode | uppercase
                }}</span>
                <span class="purchase-total">{{
                  purchaseAiCreditsService.totalDue | currency
                }}</span>
              </span>
            </p>
            @if (purchaseAiCreditsService.estimate.nextRenewalDate) {
              <p class="left-right-aligner mb-0">
                <span class="font-weight-bold"
                  >Next renewal on
                  {{
                    purchaseAiCreditsService.estimate.nextRenewalDate
                      | date: 'd-MMM-yyyy'
                  }}:</span
                >
                <span>
                  <span class="u_margin-right text-subtle">{{
                    purchaseAiCreditsService.estimate.currencyCode | uppercase
                  }}</span>
                  <span class="purchase-total">{{
                    purchaseAiCreditsService.estimate.nextRenewalTotal
                      | currency
                  }}</span>
                </span>
              </p>
            }
          </div>
        </div>

        <div class="row u_margin-md-top mb-5">
          <div class="col-md-4 mb-2">
            <button
              rv-button
              variant="secondary"
              id="cancelButton"
              type="button"
              class="tw-w-full"
              (click)="cancel()"
            >
              Cancel
            </button>
          </div>
          <div class="col-md-8">
            <button
              rv-button
              id="payButton"
              type="submit"
              class="tw-w-full"
              [disabled]="purchaseAiCreditsService.isPayButtonDisabled()"
            >
              {{ purchaseAiCreditsService.payButtonLabel }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
